import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

function CircularProgressWithLabel(
  props: CircularProgressProps & { value?: number; message?: string },
) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
      <CircularProgress  {...props} />
      {props.value !== undefined ? <Box
        sx={{
          position: 'absolute',
          top: '43%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          fontSize={'2rem'}
          sx={{ lineHeight: 1 }} 
        >{`${Math.round(props.value)}%`}</Typography>
      </Box> : <> </>}
      {props.message && (
        <Typography
          variant="subtitle2"
          component="div"
          color="text.secondary"
          sx={{ marginTop: 1 }}
        >
          {props.message}
        </Typography>
      )}
    </Box>
  );
}

export default CircularProgressWithLabel;
